export default {"src":"/_next/static/media/bookmark_regular.d450bece.svg","height":24,"width":24};